import { TrackingCategory } from '@tn/foundation/entities/tracking/const';
import { TrackerEngine } from '@tn/foundation/entities/tracking/lib/tracker-engine';
import { PAGE_TYPES, TRACK_LINK_NAMES } from '@tn/foundation/utils/constants/tracking';

import { devLog } from '../../utils/devLog';

/**
 * Tracks the email checkpoint 'Next' button select event.
 * This is called when the user submits the email checkpoint form.
 */
export const trackEmailCheckpointNextSelect = (): void => {
    try {
        void TrackerEngine.update({
            type: TRACK_LINK_NAMES.TRACK_EMAIL_CHECKPOINT_NEXT_SELECT,
            detail: {
                context: {
                    pageType: PAGE_TYPES.EMAIL_CHECKPOINT,
                },
            },
            category: TrackingCategory.App.INTERACT,
        });
    } catch (e) {
        // Don't allow tracking failures to break user flow
        devLog('[trackEmailCheckpointNextSelect] error', () => e);
    }
};
